<div class="bp-page-header">
  <div class="title-area">
    <h2>Processos de Faturamento</h2>
    <p class="subtitle">
      Conduza o ciclo de faturamento do mês passo a passo —
      mensalidades, franquias, pedidos avulsos e cobrança.
    </p>
  </div>
  <div class="actions-area">
    <button pButton type="button" class="easymarine primary" icon="pi pi-plus"
      label="Novo processo" (click)="novo()"></button>
  </div>
</div>

<div class="filter-bar">
  <label for="status-filter">Filtrar:</label>
  <p-dropdown id="status-filter" [options]="statusOptions"
    optionLabel="label" optionValue="value"
    [(ngModel)]="selectedStatus" (onChange)="onChangeStatus()"
    [showClear]="false" appendTo="body" styleClass="filter-dropdown">
  </p-dropdown>
</div>

<div *ngIf="!loading && processes.length === 0" class="empty-state">
  <i class="pi pi-inbox empty-icon"></i>
  <h3>Nenhum processo encontrado</h3>
  <p>Crie um novo processo de faturamento para começar.</p>
  <button pButton type="button" class="easymarine primary" icon="pi pi-plus"
    label="Novo processo" (click)="novo()"></button>
</div>

<div class="process-grid">
  <div class="process-card" *ngFor="let p of processes">
    <div class="card-header">
      <span class="status-badge" [ngClass]="statusBadgeClass(p.status)">
        {{ statusLabel(p.status) }}
      </span>
      <button *ngIf="p.status === 'DRAFT'" class="card-edit-icon"
        type="button" (click)="editar(p)"
        pTooltip="Editar dados do processo" tooltipPosition="left">
        <i class="pi pi-wrench"></i>
      </button>
    </div>

    <h3 class="card-title">{{ p.description }}</h3>

    <div class="card-info">
      <div class="info-row">
        <i class="pi pi-calendar"></i>
        <span>Referência: <strong>{{ formatPeriod(p.referenceMonth, p.referenceYear) }}</strong></span>
      </div>
      <div class="info-row" *ngIf="p.franchiseReferenceMonth && p.franchiseReferenceYear">
        <i class="pi pi-ticket"></i>
        <span>Franquia: <strong>{{ formatPeriod(p.franchiseReferenceMonth, p.franchiseReferenceYear) }}</strong></span>
      </div>
      <div class="info-row" *ngIf="p.marinaCompanyId">
        <i class="pi pi-building"></i>
        <span>Empresa: <strong>#{{ p.marinaCompanyId }}</strong></span>
      </div>
      <div class="info-row" *ngIf="p.currentStep">
        <i class="pi pi-list"></i>
        <span>Etapa atual: <strong>{{ p.currentStep }} de 5</strong></span>
      </div>
      <div class="info-row info-meta">
        <i class="pi pi-clock"></i>
        <span>Criado em {{ p.createdAt | date:'dd/MM/yy HH:mm' }}</span>
      </div>
    </div>

    <div class="card-actions">
      <button pButton type="button" class="easymarine primary"
        [icon]="p.status === 'DRAFT' ? 'pi pi-arrow-right' : 'pi pi-eye'"
        [label]="p.status === 'DRAFT' ? 'Continuar' : 'Abrir'"
        (click)="abrir(p)"></button>
      <button *ngIf="p.status === 'DRAFT'" pButton type="button"
        class="easymarine danger" icon="pi pi-times" label="Cancelar"
        (click)="cancelar(p)"></button>
    </div>
  </div>
</div>
